import React, { Component } from 'react'

import { AtokenProvider } from './AtokenProvider.js'
import { Auth0Context } from './Auth0Provider.js'

class AtokenFromAuth0Provider extends Component {

  // syntactic sugar for passing auth0 context to atoken provider wrapping its children

  render () {
    const props = this.props
    const children = props.children
    return (
      <Auth0Context.Consumer>
        {auth0_context => (
          <AtokenProvider {...{...auth0_context, ...props}} >
            { children }
          </AtokenProvider >
        )}
      </Auth0Context.Consumer>
    )
  }
}

export { AtokenFromAuth0Provider }



// WEBPACK FOOTER //
// ./src/authentication/AtokenFromAuth0Provider.js